export const TRIGGER_ACTION_TYPE = {
  EMAIL: 'EMAIL',
  PUBSUB: 'PUBSUB',
  NOTIFICATION: 'NOTIFICATION'
};